// OrderConfirmation.js
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMeals } from "./Meal/MealsContext";

function OrderConfirmation() {
  const { setCart } = useMeals();
  const navigate = useNavigate();
  const location = useLocation();

  const { orderNumber, firstName, lastName, noPayment } = location.state || {};

  useEffect(() => {
    if (
      !location.state ||
      orderNumber == null ||
      firstName == null ||
      lastName == null
    ) {
      navigate("/", { replace: true });
    }
  }, [location.state, orderNumber, firstName, lastName, navigate]);

  if (
    !location.state ||
    orderNumber == null ||
    firstName == null ||
    lastName == null
  ) {
    return (
      <div className="flex items-center justify-center mt-20 bg-[#fdf6eb]">
        <p className="text-gray-600">Invalid confirmation. Redirecting...</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center mt-20 bg-[#fdf6eb]">
      <div className="text-center p-10 rounded-lg  space-y-6">
        <h2 className="text-2xl font-light text-gray-700 mb-16">
          ORDER NUMBER: <span className="font-bold">{orderNumber}</span>
        </h2>
        <p className="text-xl text-gray-700">
          {noPayment
            ? "Your order has been submitted successfully "
            : "Your payment has been processed successfully "}
          <span className="font-medium">
            {firstName} {lastName}
          </span>{" "}
          !
        </p>

        <div className="flex justify-center">
          <div className="bg-[#c49a6c] my-10 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              zoomAndPan="magnify"
              viewBox="0 0 67.5 67.499996"
              height="80"
              version="1.0"
            >
              <defs>
                <clipPath id="a53a11b889">
                  <path
                    d="M 0 0 L 66.394531 0 L 66.394531 66.394531 L 0 66.394531 Z M 0 0 "
                    clipRule="nonzero"
                  />
                </clipPath>
                <clipPath id="2ea26f8e81">
                  <path
                    d="M 33.195312 0 C 14.863281 0 0 14.863281 0 33.195312 C 0 51.53125 14.863281 66.394531 33.195312 66.394531 C 51.53125 66.394531 66.394531 51.53125 66.394531 33.195312 C 66.394531 14.863281 51.53125 0 33.195312 0 Z M 33.195312 0 "
                    clipRule="nonzero"
                  />
                </clipPath>
                <clipPath id="f20dd27d6b">
                  <path
                    d="M 0 0 L 67.003906 0 L 67.003906 67.003906 L 0 67.003906 Z M 0 0 "
                    clipRule="nonzero"
                  />
                </clipPath>
              </defs>
              <g clipPath="url(#a53a11b889)">
                <g clipPath="url(#2ea26f8e81)">
                  <path
                    fill="#c09b6e"
                    d="M 0 0 L 66.394531 0 L 66.394531 66.394531 L 0 66.394531 Z M 0 0 "
                    fillOpacity="1"
                    fillRule="nonzero"
                  />
                </g>
              </g>
              <g clipPath="url(#f20dd27d6b)">
                <path
                  strokeLinecap="round"
                  transform="matrix(0.565055, 0.484739, -0.484739, 0.565055, 19.612716, 31.117801)"
                  fill="none"
                  strokeLinejoin="miter"
                  d="M 5.001722 4.999267 L 22.367478 4.999474 "
                  stroke="#fcf7ed"
                  strokeWidth="10"
                  strokeOpacity="1"
                  strokeMiterlimit="4"
                />
                <path
                  strokeLinecap="round"
                  transform="matrix(0.400337, -0.627685, 0.627685, 0.400337, 25.036947, 45.993611)"
                  fill="none"
                  strokeLinejoin="miter"
                  d="M 5.000666 4.997543 L 41.470398 4.999744 "
                  stroke="#fcf7ed"
                  strokeWidth="10"
                  strokeOpacity="1"
                  strokeMiterlimit="4"
                />
              </g>
            </svg>
          </div>
        </div>

        <p className="text-xl text-gray-700 ">
          {noPayment
            ? "Your order is pending validation."
            : "Your confirmation email has just been sent."}
        </p>
        <div className="pt-10">
          <button
            onClick={() => {
              setCart([]);
              navigate("/");
            }}
            className="px-3 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-700 text-md"
          >
            Back to menu
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderConfirmation;
